import { type IServicesCollection } from 'src/packages/di';

import alertM4a from '../assets/sound/alert.m4a';
import alertOpus from '../assets/sound/alert.opus';
import alert2M4a from '../assets/sound/alert2.m4a';
import alert2Opus from '../assets/sound/alert2.opus';

import { SoundService } from './SoundService';

function resolveSoundSource(opusUrl: string, m4aUrl: string): string {
  if (typeof Audio === 'undefined') {
    return opusUrl;
  }

  const audio = new Audio();
  const canPlayOpus = audio.canPlayType('audio/ogg; codecs="opus"') !== '';
  return canPlayOpus ? opusUrl : m4aUrl;
}

const SOUND_CONFIG = {
  alert: { url: resolveSoundSource(alertOpus, alertM4a) },
  alert2: { url: resolveSoundSource(alert2Opus, alert2M4a) },
};

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    soundService: SoundService<typeof SOUND_CONFIG>;
  }
}

export function addSoundService(di: IServicesCollection) {
  const notifyService = di.requireService('notifications');
  const getI18 = di.requireServiceAccessor('i18');
  const soundService = new SoundService(SOUND_CONFIG, () =>
    notifyService.showWarningMessage(
      getI18().t('operationalParams:activateAlarmText'),
      getI18().t('operationalParams:activateAlarmTitle'),
    ),
  );

  di.addSingleton('soundService', soundService);
}
